import {
    ADD_CARD_DETAILS_START,
    ADD_CARD_DETAILS_SUCCESS,
    ADD_CARD_DETAILS_ERROR
} from '../../constants';
import { setLoaderComplete } from '../loader/loader';
import showToaster from '../../helpers/toastrMessgaes/showToaster';
import { closeHeaderModal } from '../siteadmin/modalActions';
import { addCardDetails as mutation, getPaymentMethod as query } from '../../lib/graphql';
import { confirmSetupIntentAction } from './confirmSetupIntentAction';
import history from '../../history';

export function addCardDetailsAction({ stripe, paymentMethodId, cardLastFour, orderId, bookingId }) {
    return async (dispatch, getState, { client }) => {
        try {
            dispatch({
                type: ADD_CARD_DETAILS_START,
            });

            const { data } = await client.mutate({
                mutation,
                variables: {
                    paymentMethod: paymentMethodId,
                    cardLastFour
                },
                refetchQueries: [{ query }]
            });

            if (data?.addCardDetails?.status === 200) {
                if (data?.addCardDetails?.result?.requireAdditionalAction) {
                    const { error: actionError, setupIntent } = await stripe.confirmCardSetup(data?.addCardDetails?.result?.paymentIntentSecret);
                    if (actionError) {
                        let errorMessage = actionError.message
                        showToaster({ messageId: 'catchMessage', requestContent: errorMessage, toasterType: 'error' });
                        dispatch(setLoaderComplete('addCardDetails'));
                    } else if (setupIntent?.status === 'succeeded') {
                        const setupIntentId = setupIntent?.id;
                        dispatch(confirmSetupIntentAction({ setupIntentId, paymentMethodId, cardLastFour, orderId, bookingId }))
                    }
                    dispatch({
                        type: ADD_CARD_DETAILS_ERROR,
                    });
                } else {
                    dispatch(setLoaderComplete('addCardDetails'))
                    orderId
                        ? history.push(`/order/${orderId}`)
                        : (bookingId
                            ? history.push(`/tracking/${bookingId}`) 
                            : history.push('/payment-method'));
                    await showToaster({ messageId: 'cardAddSuccess', toasterType: 'success' });
                    dispatch({
                        type: ADD_CARD_DETAILS_SUCCESS,
                    });
                }
            } else {
                let errorMessage = data?.addCardDetails?.errorMessage
                showToaster({ messageId: 'errorMessage', requestContent: errorMessage, toasterType: 'error' });
                dispatch(setLoaderComplete('addCardDetails'));
            }
        } catch (error) {
            dispatch({
                type: ADD_CARD_DETAILS_ERROR,
            });
            dispatch(setLoaderComplete('addCardDetails'));
            return {
                status: '400'
            };
        }
        return {
            status: '200'
        };
    };
}